import Copy from "csi/table/Copy";
import declare from "dojo/_base/declare";
import _ from "lodash";
import MultiActionPopupMixin from "csi/action/MultiActionPopupMixin";
import ProductHierarchyFoodNewCopyParams from "src/SiteAdmin/ProductHierarchy/ProductHierarchyFoodNewCopyParams";
import Writer from "csi/xml/Writer";

const ProductHierarchyCopyFood = declare([Copy, MultiActionPopupMixin, ProductHierarchyFoodNewCopyParams], {
	// Dialog localization strings
	loadingMessageTemplateSingular: "MultiCopyFood_LoadingSingular",
	loadingMessageTemplatePlural: "MultiCopyFood_LoadingPlural",
	successMessageTemplateSingular: "MultiCopyFood_SuccessSingular",
	successMessageTemplatePlural: "MultiCopyFood_SuccessPlural",

	// String: name of field containing number of nodes to create
	numCreateField: "CopyCount",

	/**
	 * @override
	 * Overridden to prevent ValidateAndDeleteIfFailed call on frontend, validation is handled in java operation
	 */
	_toWriterValidateNode() {
		const w: Writer = this.m_writer;

		w.flushChanges();
	},
});

export = ProductHierarchyCopyFood;